module.exports = __webpack_public_path__ + "img/chart4-md.1ef6797c.webp";